import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import styles from "assets/jss/components/customcomponents/typographyStyle.js";

const useStyles = makeStyles(styles);

export default function Info(props) {
  const classes = useStyles();
  const { children,style } = props;
  return (
    <div className={classes.defaultFontStyle + " " + classes.infoText} style={style}>
      {children}
    </div>
  );
}

Info.propTypes = {
  children: PropTypes.node,
  style:PropTypes.object
};
